import { css } from 'styled-components';

import type { TooltipPosition } from './TooltipPosition';
import type { TooltipSize } from './TooltipSize';

export const arrowPositionStyles = (
  placement: TooltipPosition,
  targetWidth: number,
  size: TooltipSize,
) => {
  const arrowSize = size === 'large' ? '19px' : '10px';

  const commonStyles = css`
    &::before {
      width: ${arrowSize};
      height: ${arrowSize};
      transform: rotate(45deg) skew(12deg, 12deg);
    }
  `;

  const topStyles = css`
    &::before {
      bottom: calc(-${arrowSize} / 2);
      border-top: none;
    }
  `;

  const bottomStyles = css`
    &::before {
      top: calc(-${arrowSize} / 2);
      border-bottom: none;
    }
  `;

  const centerStyles = css`
    &::before {
      left: 50%;
      margin-left: calc(-${arrowSize} / 2);
      ${
        placement === 'bottom-center'
          ? 'border-right: none'
          : 'border-left: none'
      };
    }
  `;

  const leftStyles = css`
    &::before {
      right: max(calc(${targetWidth / 2}px - (${arrowSize} / 2)), ${arrowSize});
      border-right: none;
    }
  `;

  const rightStyles = css`
    &::before {
      left: max(calc(${targetWidth / 2}px - (${arrowSize} / 2)), ${arrowSize});
      border-right: none;
    }
  `;

  switch (placement) {
    case 'bottom-center':
      return css`
        ${commonStyles}
        ${bottomStyles}
        ${centerStyles}
      `;
    case 'bottom-left':
      return css`
        ${commonStyles}
        ${bottomStyles}
        ${leftStyles}
      `;
    case 'bottom-right':
      return css`
        ${commonStyles}
        ${bottomStyles}
        ${rightStyles}
      `;

    case 'top-center':
      return css`
        ${commonStyles}
        ${topStyles}
        ${centerStyles}
      `;
    case 'top-left':
      return css`
        ${commonStyles}
        ${topStyles}
        ${leftStyles}
      `;
    case 'top-right':
      return css`
        ${commonStyles}
        ${topStyles}
        ${rightStyles}
      `;
    default:
      return null;
  }
};
